var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"icon",class:[_vm.type != '' ? 'is-' + _vm.type : ''],attrs:{"icon":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }